import { computed } from 'vue';
import { Transliterate } from '#shared/helpers';

export function usePdpRouteHandler() {
  const router = useRouter();
  const route = useRoute();

  const routeSkuId = computed(() => (route.query.skuId ? Number(route.query.skuId) : undefined));

  const routeProductId = computed(() => {
    const id = route.params.id;
    return Array.isArray(id) ? id[0] : id;
  });

  const routeProductName = computed(() => {
    const name = route.params.name;
    return Array.isArray(name) ? name[0] : name;
  });

  async function updateRouteProductTitle(title?: string) {
    if (!title) return;

    const slug = Transliterate.productTitle(title);

    return router.replace({
      path: slug + route.params.id,
      query: route.query,
    });
  }

  return { routeSkuId, routeProductId, routeProductName, updateRouteProductTitle };
}
